/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useRef, useState, useCallback, Fragment } from "react";
import { FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Close } from "@material-ui/icons";
import { ReuseComponentDialogContext } from "cms/components/layout/reuse/find-component/context";
import debounce from "lodash.debounce";
import { isArrayNotEmpty } from "utils/empty-exists";
import {
    useComponentsWithCategories
} from "cms/models/hooks/use-components-with-categories";

const DataGridFilterRow = (props) => {

    const { filter } = props;
    const firstUpdate = useRef(true);
    const {
        updateFilter,
        removeFilter,
        columnDefinitions,
        filterOperators
    } = useContext(ReuseComponentDialogContext);

    const [localState, setLocalState] = useState({ ...filter });
    const [column, setColumn] = useState(filter?.column);
    const [operator, setOperator] = useState(filter?.operator);
    const [value, setValue] = useState(filter?.value);
    const componentTypes = useComponentsWithCategories();
    const typeMode = column === "type" && operator === "equals" && isArrayNotEmpty(componentTypes);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((newFilter) => {
            if (firstUpdate.current) {
                firstUpdate.current = false;
                return;
            }
            updateFilter(newFilter);
        }, 1000),
        [updateFilter]
    );
    // useEffect(() => {
    //     if (column === 'type') {
    //         setOperator('equals')
    //     }
    // }, [column])
    const onRemove = () => {
        removeFilter(localState.guid);
        setColumn(undefined);
        setOperator(undefined);
        setValue(undefined);
    };
    const onChangeColumn = (event) => {
        const column = event.target.value;
        setColumn(column);
        const newFilter = { ...localState, column: column };
        setLocalState(newFilter);
        update(newFilter);
    };
    const onChangeOperator = (event) => {
        const operator = event.target.value;
        setOperator(operator);
        const newFilter = { ...localState, operator: operator };
        setLocalState(newFilter);
        update(newFilter);
    };
    const onChangeValue = (event) => {
        const value = event.target.value;
        setValue(value);
        const newFilter = { ...localState, value: value };
        setLocalState(newFilter);
        update(newFilter);
    };

    return (
        <div className='data-grid-filters-row'>

            <IconButton
                color='neutral'
                onClick={onRemove}
            >
                <Close />
            </IconButton>


            <FormControl>
                <InputLabel variant='standard' htmlFor='uncontrolled-native'>
                    Column
                </InputLabel>
                {columnDefinitions &&
                    <Select
                        variant='standard'
                        size={"small"}
                        value={column}
                        label='Column'
                        onChange={onChangeColumn}
                    >
                        {columnDefinitions.map((col, idx) => {
                            return (
                                <MenuItem key={`coldef-${idx}`} value={col.field}>
                                    {col.headerName}
                                </MenuItem>
                            );
                        })}
                    </Select>
                }
            </FormControl>

            {typeMode &&
                <Fragment>
                    <FormControl>
                        <InputLabel variant='standard' htmlFor='uncontrolled-native'>
                            Operator
                        </InputLabel>
                        <Select
                            variant='standard'
                            size={"small"}
                            value={operator}
                            label='Column'
                        >
                            <MenuItem key={"opdef-none"} value={"equals"}>
                                Equals
                            </MenuItem>
                        </Select>
                    </FormControl>
                    <Select
                        variant='standard'
                        size={"small"}
                        value={value}
                        label='Column'
                        onChange={onChangeValue}
                    >
                        {!value &&
                            <MenuItem key={""} value={""}>
                                Please Select...
                            </MenuItem>
                        }
                        {componentTypes.map((ctype, idx) => {
                            return (
                                <MenuItem key={`valuedef-${idx}`} value={ctype.type}>
                                    {ctype.text}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </Fragment>
            }

            {!typeMode &&
                <Fragment>
                    <FormControl>
                        <InputLabel variant='standard' htmlFor='uncontrolled-native'>
                            Operator
                        </InputLabel>
                        {filterOperators &&
                            <Select
                                variant='standard'
                                size={"small"}
                                value={operator}
                                label='Column'
                                onChange={onChangeOperator}
                            >
                                {filterOperators.map((operator, idx) => {
                                    return (
                                        <MenuItem key={`opdef-${idx}`} value={operator.key}>
                                            {operator.label}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        }
                    </FormControl>

                    <FormControl>
                        <TextField
                            variant='standard'
                            label='Value'
                            placeholder='Filter value'
                            value={value}
                            onChange={onChangeValue}
                            InputLabelProps={{ shrink: true }}
                        />
                    </FormControl>
                </Fragment>
            }
        </div>
    );
};
export { DataGridFilterRow };
